import { createServerFn } from "@tanstack/react-start";
import { AnalyseInput } from "./klus-analyse-schema";
import { analyseerKlusServer } from "./klus-analyse.server";
export { KLUS_CATEGORIEEN } from "./klus-analyse-schema";
export type { KlusAnalyse } from "./klus-analyse-schema";

export const analyseerKlus = createServerFn({ method: "POST" })
  .inputValidator((input: unknown) => AnalyseInput.parse(input))
  .handler(({ data }) => analyseerKlusServer(data));
